import React from 'react';
import { Alert } from 'react-bootstrap';
import HotelRoomLoader from './HotelRoomLoader';
import RoomRateCard from './RoomRateCard';
import useRoomRate from '../../state/room-rate/hooks/useProducer';

export default function RoomListCard() {
  const { roomRate } = useRoomRate();

  if (roomRate.isLoading) {
    return <HotelRoomLoader />;
  }
  if (roomRate.rooms.length === 0) {
    return (
      <Alert key="dark" variant="dark">
        No rate found
      </Alert>
    );
  }
  return roomRate.rooms.map((r) => {
    return <RoomRateCard key={r.id} room={r} />;
  });
}
